import { Button } from "@/components/ui/button";
import { Typography } from "@/components/ui/typography";

/**
 * Props for the MaterialMatchingQuestion component
 */
interface MaterialMatchingQuestionProps {
  /**
   * Callback function invoked when user answers the material matching question
   * @param answer - true if materials should match, false otherwise
   */
  onAnswer: (answer: boolean) => void;
}

/**
 * MaterialMatchingQuestion Component
 *
 * Displays a question asking if the enclosure materials should match the component materials.
 * Provides Yes/No buttons for user response.
 *
 * @example
 * ```tsx
 * <MaterialMatchingQuestion
 *   onAnswer={(answer) => setMatchMaterials(answer)}
 * />
 * ```
 */
export function MaterialMatchingQuestion({ onAnswer }: MaterialMatchingQuestionProps) {
  return (
    <div className="flex flex-col gap-2">
      <Typography variant="text-xl" weight="semibold" className="text-center">
        Do you want to match the enclosure materials with the existing components materials?
      </Typography>
      <div className="flex justify-center gap-2">
        <Button variant="outline" onClick={() => onAnswer(false)}>
          No
        </Button>
        <Button onClick={() => onAnswer(true)}>Yes</Button>
      </div>
    </div>
  );
}
